import React, { useState } from 'react';
import AddAchievementModal from '../modals/AddAchievementModal';

const AchievementsSection = ({ isEditing, achievements = [], onUpdateAchievements }) => {
  const [showAchievementModal, setShowAchievementModal] = useState(false);

  const handleAddAchievement = (achievementData) => {
    const newAchievement = {
      id: Date.now(),
      ...achievementData
    };
    onUpdateAchievements([...achievements, newAchievement]);
    setShowAchievementModal(false);
  };

  const handleRemoveAchievement = (achievementId) => {
    const updatedAchievements = achievements.filter(achievement => achievement.id !== achievementId);
    onUpdateAchievements(updatedAchievements);
  };

  return (
    <div className="bg-white p-6 border border-[#E6E6E6]">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-[11px] font-bold text-[#3C3C3C]">ACHIEVEMENTS / TROPHIES</h2>
        {isEditing && (
          <button
            onClick={() => setShowAchievementModal(true)}
            className="px-4 py-2 border border-[#E6E6E6] bg-white text-[#1E1E1E] rounded-lg"
          >
            + Add
          </button>
        )}
      </div>

      <div className=" rounded-xl">
        {/*
          A fixed three-way split left each card ~85px wide at 375px: the
          titles were cut to "Bu…", the cards ran +88px past the screen in the
          read state and +116px while editing, and the remove button was
          squeezed from 32px to 12px. Even at 768px three columns only left the
          title 45px once the button keeps its size.

          This is the same ladder the PUBLIC coach profile already uses for the
          very same trophy cards (CoachPersonalInfo.js) — stacked on a phone,
          two up on a tablet, three from `lg`. Desktop (>=1024px) is unchanged.
        */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {achievements.length === 0 && (
            <div className="w-full text-sm text-gray-500">No achievements added yet.</div>
          )}
          
          {achievements.map((achievement) => (
            <div
              key={achievement.id}
              className="border border-[#BCCAD7] bg-[#F8F9FB] p-4 rounded-xl flex gap-4"
            >
              <div className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 overflow-hidden">
                {achievement.image ? (
                  <img
                    src={achievement.image instanceof File ? URL.createObjectURL(achievement.image) : achievement.image}
                    alt={achievement.title}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      // Fallback to trophy icon if image fails to load
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                ) : null}
                <div className={`w-full h-full bg-yellow-500 flex items-center justify-center ${achievement.image ? 'hidden' : ''}`}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 9H4.5C4.5 6.51472 6.51472 4.5 9 4.5H15C17.4853 4.5 19.5 6.51472 19.5 9H18C18 7.34315 16.6569 6 15 6H9C7.34315 6 6 7.34315 6 9Z" fill="white"/>
                    <path d="M12 4.5V6M12 18V19.5M4.5 12H6M18 12H19.5M7.5 7.5L8.5 8.5M15.5 15.5L16.5 16.5M8.5 15.5L7.5 16.5M16.5 7.5L15.5 8.5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
                    <path d="M12 6C14.2091 6 16 7.79086 16 10V12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12V10C8 7.79086 9.79086 6 12 6Z" fill="white"/>
                  </svg>
                </div>
              </div>
              {/*
                `min-w-0` lets this column shrink below its longest word — a
                flex item refuses to by default, which is how a long trophy
                title used to push the whole card wider than the screen.
              */}
              <div className="flex flex-col flex-1 min-w-0 break-words">
                <span className="text-[#222A35] text-[20px] font-bold">{achievement.title}</span>
                {achievement.club && (
                  <span className="text-[#222A35] text-[16px] font-bold">{achievement.club}</span>
                )}
                <span className="text-[#646B7E] text-[14px]">{achievement.year}</span>
              </div>
              {isEditing && (
                <button
                  onClick={() => handleRemoveAchievement(achievement.id)}
                  // flex-shrink-0 keeps the remove button a circle; without it
                  // a narrow card squeezed it into an ellipse.
                  className="w-8 h-8 flex-shrink-0 bg-[#FF4D4F1A] border border-[#FF4D4F] rounded-full flex items-center justify-center ml-auto"
                >
                  <span className="text-[#FF4D4F] text-sm font-bold">×</span>
                </button>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Achievement Modal */}
      {showAchievementModal && (
        <AddAchievementModal
          onClose={() => setShowAchievementModal(false)}
          onAdd={handleAddAchievement}
        />
      )}
    </div>
  );
};

export default AchievementsSection; 